import { ThemeOptions, createTheme } from "@mui/material";
import { colors } from "colors";

const presetTheme = createTheme({
  shape: {
    borderRadius: 12,
  },
  typography: {},
});

export const themeOptions: ThemeOptions = createTheme(presetTheme, {
  ...presetTheme,
  palette: {
    mode: "light",
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
    error: {
      main: colors.error,
    },
    gray: {
      color: colors.lightGray,
    },

    notification: {
      main: "#ff004a",
    },
  },
  typography: {
    fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    secondaryText: {
      color: "#a4a4a4",
      fontWeight: 600,
      padding: 15,
      fontSize: 14,
    },

    impressum: {
      fontSize: 12,
    },

    tableTitle: {
      fontSize: 32,
      fontWeight: 700,
      color: "#3790ff",
    },

    xl: {
      fontSize: 64,
      fontWeight: 700,
    },

    sm: {
      color: "#388e3c",
      fontWeight: 700,
      fontSize: 18,
    },

    tableSubtitle: {
      fontSize: 20,
    },

    weekQuestion: {
      fontWeight: 700,
      fontSize: 18,
    },

    dashboardHeader: {
      fontSize: 24,
      margin: 30,
      marginLeft: 5,
      marginBottom: 15,
    },

    avatarHeader: {
      fontSize: 42,
      fontWeight: 700,
      [presetTheme.breakpoints.down("md")]: {
        fontSize: 32,
      },
    },

    objectionAnswers: {
      fontSize: 32,
      color: "#3790ff",
      marginLeft: 16,
    },
    objectionAnswersSm: {
      fontSize: 20,
      color: "rgb(12, 75, 118)",
      fontWeight: 700,
      marginLeft: 16,
    },

    paperHeader: {
      fontSize: 20,
      maxWidth: 500,
      textAlign: "left",
    },

    avatarContent: {
      fontSize: 24,
      // color: '#0c4b76'
      color: "black",
    },

    documentTitle: {
      fontSize: 32,
      fontWeight: 700,
      // color: "#3790fb",
    },

    cardContent: {
      fontSize: 17,
    },

    commentTitle: {
      fontSize: 20,
      fontWeight: 700,
      // color: "#ffffff",
    },

    avatar: {
      fontSize: 32,
      fontWeight: 900,
    },

    banner: {
      fontSize: 12,
    },

    h1: {
      fontSize: 24,
      fontWeight: "bold",
    },
    subheader1: {
      fontSize: 16,
      color: "#666",
    },

    h2: {
      fontSize: 36,
      fontWeight: 500,
    },
    h3: {
      fontSize: 28,
      fontWeight: 500,
      color: "#363636",
    },
    b: {
      fontWeight: 600,
    },
    light: {
      fontWeight: 200,
    },

    cardTitle: {
      fontSize: 22,
      fontWeight: 600,
      color: "#363636",
      lineHeight: "36px",
    },
    cardSubtitle: {
      fontSize: 16,
      marginBottom: 10,
      lineHeigth: "8px",
    },

    questionTitle: {
      fontSize: 28,
      fontWeight: 600,
      color: "#363636",
      lineHeight: "36px",
    },
    questionSubtitle: {
      fontSize: 16,
      marginBottom: 10,
      lineHeigth: "8px",
    },
    button: {
      fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
      textTransform: "none",
      fontSize: 16,
      fontWeight: 600,
      letterSpacing: -0.3,
    },
    smallListItem: {
      fontSize: 12,
    },
  },
  components: {
    MuiAppBar: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          background: "#FFFF",
        },
      },
    },
    MuiAccordion: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          "&:before": {
            display: "none",
          },
          border: "1px solid #eceff1",
          borderRadius: "8px",
        },
      },
    },
    MuiTextField: {
  styleOverrides: {
    root: {
      '& .MuiOutlinedInput-root': {
        background: 'var(--gray-100, #F8F9FA)',
        borderRadius: '8px',

        '& fieldset': {
          border: '1px solid var(--gray-200, #E9ECEF)'
        },

        '&:hover fieldset': {
          border: '1px solid var(--gray-200, #E9ECEF)'
        },

        '&.Mui-focused fieldset': {
          border: '1px solid #1976d2'
        }
      }
    }
  }
},

    MuiFormControl: {
      styleOverrides: {
        root: {
          backgroundColor: "#f1f1f1",
          borderRadius: presetTheme.shape.borderRadius,
          input: {
            borderRadius: presetTheme.shape.borderRadius,
            fontSize: 18,
            border: "none",
          },
          fieldSet: {
            borderRadius: presetTheme.shape.borderRadius,
            border: "#f1f1f1",
          },
          border: "none",
        },
      },

      defaultProps: {
        // disableElevation: true,
        variant: "outlined",
        color: "gray",
      },
    },
    MuiFormGroup: {
      styleOverrides: {
        root: {
          borderRadius: presetTheme.shape.borderRadius,
          input: {
            borderRadius: presetTheme.shape.borderRadius,
            fontSize: 18,
            border: "none",
          },
          fieldSet: {
            borderRadius: presetTheme.shape.borderRadius,
            border: "#f1f1f1",
          },
          border: "none",
        },
      },

      defaultProps: {
        // disableElevation: true,
        variant: "outlined",
        color: "gray",
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          borderRadius: presetTheme.shape.borderRadius,
          border: "#f1f1f1",
        },
        border: "#f1f1f1",
      },

      defaultProps: {
        // disableElevation: true,
        variant: "outlined",
        color: "gray",
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: presetTheme.shape.borderRadius,
          fontSize: 18,
          borderBottom: "0px",
        },
        border: "none",
      },

      defaultProps: {
        inputProps: {
          input: {
            // disableElevation: true,
            variant: "outlined",
            color: "gray",
          },

          root: {
            // disableElevation: true,
            variant: "outlined",
            color: "gray",
            border: "#f1f1f1",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          // apply theme's border-radius instead of component's default
          borderRadius: 8,
        },
      },
      defaultProps: {
        // disableElevation: true,
        variant: "contained",

        disableFocusRipple: true,
        // disableRipple: true,
        // style: { padding: "25px" },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: "solid 1px #e0e0e0",
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          // border: "solid 1px #e0e0e0",
          borderRadius: presetTheme.shape.borderRadius,
        },
      },
      defaultProps: {
        elevation: 0,
      },
    },
  },

  shadows: [
    "none",
    "0px 3px 9px -0.1px rgba(0,0,0,0.1),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0.1px 0.3px 0px rgba(0,0,0,0.12)",
    "0px 3px 9px -0.1px rgba(0,0,0,0.1),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0.1px 0.3px 0px rgba(0,0,0,0.12)",
    "0px 3px 9px -0.1px rgba(0,0,0,0.1),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0.1px 0.3px 0px rgba(0,0,0,0.12)",
    "0px 3px 9px -0.1px rgba(0,0,0,0.1),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0.1px 0.3px 0px rgba(0,0,0,0.12)",
    "0px 3px 9px -0.1px rgba(0,0,0,0.1),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0.1px 0.3px 0px rgba(0,0,0,0.12)",
    "0px 3px 9px -0.1px rgba(0,0,0,0.1),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0.1px 0.3px 0px rgba(0,0,0,0.12)",
    "0px 3px 9px -0.1px rgba(0,0,0,0.1),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0.1px 0.3px 0px rgba(0,0,0,0.12)",
    "0px 3px 9px -0.1px rgba(0,0,0,0.1),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0.1px 0.3px 0px rgba(0,0,0,0.12)",
    "0px 3px 9px -0.1px rgba(0,0,0,0.1),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0.1px 0.3px 0px rgba(0,0,0,0.12)",
    "0px 3px 9px -0.1px rgba(0,0,0,0.1),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0.1px 0.3px 0px rgba(0,0,0,0.12)",
    "0px 3px 9px -0.1px rgba(0,0,0,0.1),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0.1px 0.3px 0px rgba(0,0,0,0.12)",
    "0px 0.3px 0.1px -0.2px rgba(0,0,0,0.2),0px 0.2px 0.2px 0px rgba(0,0,0,0.14),0px 0.1px 0.5px 0px rgba(0,0,0,0.12)",
    "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
    "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
    "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
    "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
    "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
    "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
    "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
    "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
    "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
    "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
    "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
    "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
    "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
    "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
    "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
    "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
    "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
    "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
    "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
    "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
    "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
    "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
  ],
});
export const theme = createTheme(themeOptions);
